import { isValidEmail } from '@domain-group/javascript-utils'

export type SystemModel = {
  accounts_email?: string,
  accounts_phone?: string,
  bank_account_bsb?: string,
  bank_account_name?: string,
  bank_account_number?: string,
  business_number?: string,
  cache_key: number,
  email?: string,
  maintenance_message?: string,
  maintenance_mode: false,
  id: number,
  options: any,
  short_name?: string,
  title: string,
  url: string,
}

const state = {
  accounts_email: '',
  accounts_phone: '',
  bank_account_bsb: '',
  bank_account_name: '',
  bank_account_number: '',
  business_number: '',
  email: '',
  maintenance_message: '',
  maintenance_mode: false,
  id: null,
  options: {
    slack_api_debug_webhook_url: '',
    slack_preflight_webhook_url: '',
    slack_publications_webhook_url: '',
    slack_templates_webhook_url: '',
    teams_api_debug_webhook_url: '',
    teams_preflight_webhook_url: '',
    teams_publications_webhook_url: '',
    teams_templates_webhook_url: '',
  },
  short_name: '',
  title: '',
  url: '',
}

export const requiredFields = [
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'title' },
  { key: 'url' },
]

export default state
